import { RSAA } from 'redux-api-middleware';
import endpoints from '../../utils/endpoints';

export const SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_REQUEST = 'SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_REQUEST';
export const SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_SUCCESS = 'SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_SUCCESS';
export const SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_FAILURE = 'SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_FAILURE';
export const SUBMIT_CHAPS_PAYMENT_REVIEW_REQUEST = 'SUBMIT_CHAPS_PAYMENT_REVIEW_REQUEST';
export const SUBMIT_CHAPS_PAYMENT_REVIEW_SUCCESS = 'SUBMIT_CHAPS_PAYMENT_REVIEW_SUCCESS';
export const SUBMIT_CHAPS_PAYMENT_REVIEW_FAILURE = 'SUBMIT_CHAPS_PAYMENT_REVIEW_FAILURE';
export const SUBMIT_CHAPS_CONFIRMED_PAYMENT_REQUEST = 'SUBMIT_CHAPS_CONFIRMED_PAYMENT_REQUEST';
export const SUBMIT_CHAPS_CONFIRMED_PAYMENT_SUCCESS = 'SUBMIT_CHAPS_CONFIRMED_PAYMENT_SUCCESS';
export const SUBMIT_CHAPS_CONFIRMED_PAYMENT_FAILURE = 'SUBMIT_CHAPS_CONFIRMED_PAYMENT_FAILURE';
export const SUBMIT_BATCH_CHAPS_REVIEW_REQUEST = 'SUBMIT_BATCH_CHAPS_REVIEW_REQUEST';
export const SUBMIT_BATCH_CHAPS_REVIEW_SUCCESS = 'SUBMIT_BATCH_CHAPS_REVIEW_SUCCESS';
export const SUBMIT_BATCH_CHAPS_REVIEW_FAILURE = 'SUBMIT_BATCH_CHAPS_REVIEW_FAILURE';
export const SUBMIT_CHAPS_BATCH_REQUEST = 'SUBMIT_CHAPS_BATCH_REQUEST';
export const SUBMIT_CHAPS_BATCH_SUCCESS = 'SUBMIT_CHAPS_BATCH_SUCCESS';
export const SUBMIT_CHAPS_BATCH_FAILURE = 'SUBMIT_CHAPS_BATCH_FAILURE';
export const SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_REQUEST = 'SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_REQUEST';
export const SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_SUCCESS = 'SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_SUCCESS';
export const SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_FAILURE = 'SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_FAILURE';
export const SUBMIT_CHAPS_EDIT_PAYMENT_REQUEST = 'SUBMIT_CHAPS_EDIT_PAYMENT_REQUEST';
export const SUBMIT_CHAPS_EDIT_PAYMENT_SUCCESS = 'SUBMIT_CHAPS_EDIT_PAYMENT_SUCCESS';
export const SUBMIT_CHAPS_EDIT_PAYMENT_FAILURE = 'SUBMIT_CHAPS_EDIT_PAYMENT_FAILURE';
export const SUBMIT_GET_CHAPS_PAYMENT_TO_EDIT_REQUEST = 'SUBMIT_GET_CHAPS_PAYMENT_TO_EDIT_REQUEST';
export const SUBMIT_GET_CHAPS_PAYMENT_TO_EDIT_SUCCESS = 'SUBMIT_GET_CHAPS_PAYMENT_TO_EDIT_SUCCESS';
export const SUBMIT_GET_CHAPS_PAYMENT_TO_EDIT_FAILURE = 'SUBMIT_GET_CHAPS_PAYMENT_TO_EDIT_FAILURE';

export const submitChapsPaymentsForDailyLimitReview = (payments) => {
	const body = JSON.stringify(payments);
	const endpoint = endpoints.multipart.uri;

	return {
		[RSAA]: {
			endpoint,
			method: 'POST',
			types: [
				SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_REQUEST,
				SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_SUCCESS,
				SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_FAILURE,
			],
			body,
			headers: { 'x-bpi-version': endpoints.multipart.x_bpi_version },
		},
	};
};

export const submitChapsPaymentsForReview = (payments, userId) => {
	const body = JSON.stringify(payments);
	const endpoint = endpoints.multipart.uri;
	const successAction = {
		type: SUBMIT_CHAPS_PAYMENT_REVIEW_SUCCESS,
		meta: { userId },
	};
	return {
		[RSAA]: {
			endpoint,
			method: 'POST',
			types: [SUBMIT_CHAPS_PAYMENT_REVIEW_REQUEST, successAction, SUBMIT_CHAPS_PAYMENT_REVIEW_FAILURE],
			body,
			headers: { 'x-bpi-version': endpoints.multipart.x_bpi_version },
		},
	};
};

export const submitConfirmedChapsPayments = (payments) => {
	const body = JSON.stringify(payments);
	const endpoint = endpoints.multipart.uri;

	return {
		[RSAA]: {
			endpoint,
			method: 'POST',
			types: [
				SUBMIT_CHAPS_CONFIRMED_PAYMENT_REQUEST,
				SUBMIT_CHAPS_CONFIRMED_PAYMENT_SUCCESS,
				SUBMIT_CHAPS_CONFIRMED_PAYMENT_FAILURE,
			],
			body,
			headers: { 'x-bpi-version': endpoints.multipart.x_bpi_version },
		},
	};
};

export const chapsEditPayment = (payment, editPaymentRequestBody, state, paymentID) => {
	const body = JSON.stringify(editPaymentRequestBody);
	const endpoint = endpoints.editChapsPayment;
	const { bankId } = state.session;
	const uri = endpoint.resolve(bankId, 'default', payment.fromAccount, paymentID);
	return {
		[RSAA]: {
			endpoint: uri,
			method: endpoint.method,
			types: [SUBMIT_CHAPS_EDIT_PAYMENT_REQUEST, SUBMIT_CHAPS_EDIT_PAYMENT_SUCCESS, SUBMIT_CHAPS_EDIT_PAYMENT_FAILURE],
			body,
		},
	};
};

export const getCHAPSPaymentToEdit = ({ paymentId, account }, state) => {
	const endpoint = endpoints.getPaymentById;
	const { bankId } = state.session;
	const uri = endpoint.resolve(bankId, 'default', account, paymentId);
	return {
		[RSAA]: {
			endpoint: uri,
			method: endpoint.method,
			types: [
				SUBMIT_GET_CHAPS_PAYMENT_TO_EDIT_REQUEST,
				SUBMIT_GET_CHAPS_PAYMENT_TO_EDIT_SUCCESS,
				SUBMIT_GET_CHAPS_PAYMENT_TO_EDIT_FAILURE,
			],
		},
	};
};
